import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { BaseService } from './base.service';

@Injectable()
export class AdUnitService extends BaseService {
    constructor(protected http: Http) {
        super('adunits', http);
    }

    listBySiteId(siteId: string) {
        return this.http
            .get('/' + this.path + '/listbysiteid', {
                params: { siteId: siteId }
            })
            .map(this.extractData);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/services/adunit.service.ts